import { useAuth0 } from '@auth0/auth0-react';
import { useUserDataQuery } from '@shared/queries';
import { getGreeting } from '@shared/greeting';
import { smsExample, SMS_EXAMPLE_VALUES } from './smsEstimate';

// Personalize previews only. Real messages still use the visit's client data.
export function useSmsPreview() {
  const { user } = useAuth0();
  const { data: profile } = useUserDataQuery();
  const lastName = user?.family_name?.trim();
  const clientName = lastName
    ? getGreeting(lastName).replace(/,\s*$/, '')
    : profile?.name?.trim() || user?.name?.trim() || SMS_EXAMPLE_VALUES.clientName;
  return (content: string) =>
    smsExample(content, {
      clientName,
      bankAccount: profile?.bankAccount?.trim() || SMS_EXAMPLE_VALUES.bankAccount,
      reviewUrl: profile?.reviewUrl?.trim() || SMS_EXAMPLE_VALUES.reviewUrl,
    });
}
